module.exports = __webpack_public_path__ + "static/media/wechat.8ea8e478.svg";